(function ($) {
    jQuery(document).ready(function () {
      // Toolbar Hidden
      $(".announcement__close").on("click", function(e) {
          e.preventDefault();
          $('.toolbar-section').hide();    
          setCookie("announcementBar", 1, 7);
      }); 
      if (getCookie("announcementBar") != "") {
          $('.toolbar-section').hide().removeClass('notification--active');
      } else {
          $('.toolbar-section').show().addClass('notification--active');
      }

      // Mobile nave trigger
      $("button.mobile-nav-trigger").on("click", function(e) {
        if($('body').hasClass('mobile-nav-open')) {
            $('html').removeClass('html-nav-open');
            $('body').removeClass('mobile-nav-open'); 
            $('.site-header__mobile-nav').removeClass('nav-active');
        } else {
            $('html').addClass('html-nav-open');
            $('body').addClass('mobile-nav-open');
            $('.site-header__mobile-nav').addClass('nav-active');
        }
      });

      // Megamenu dropdow right
      $(document).on("click",".site-nav__dropdown.megamenu--collections .megamenu__col-title input",function() {
        // $(this).addClass('active').removeClass('once-click');
        $(this).parent('.megamenu__col-title').addClass('active');
        $(this).parent('.megamenu__col-title').siblings('.megamenu__col-title').removeClass('active').find('a').removeClass('active');
      });
      
      // $(document).on("click",".site-nav__dropdown.megamenu--collections .megamenu__col-title > a.site-nav__click",function(e) {
      //   if($(this).hasClass('once-click')) {
      //     e.preventDefault();            
      //   }
      //   $(this).addClass('active').removeClass('once-click');
      //   $(this).parent('.megamenu__col-title').addClass('active');
      //   $(this).siblings('.megamenu__col-title').removeClass('active').find('a').removeClass('active');
      // });
      // Nav item hover
      // $( ".site-nav__item" ).hover(
      //   function() {
      //     //
      //   }, function() {
      //     $('.site-nav__dropdown.megamenu--collections .megamenu__col-title, .site-nav__dropdown.megamenu--collections .megamenu__col-title > a').removeClass('active');
      //     $('.site-nav__dropdown.megamenu--collections .megamenu__col-title > a.site-nav__click').addClass('once-click');
      //   }
      // );

      // Search Header
      $('predictive-search form .search__input').on("click", function(e) {
        $(this).parents('form').addClass('active-form');
        // if($('body').hasClass('mobile-nav-open')) {
        //   $('body').removeClass('mobile-nav-open');
        // }
      })

      // Click outside to close element
      if($("header-drawer.site-header__mobile-nav").length > 0) {
        $(document).on( "mouseup", function(e) {
            var container = $("header-drawer.site-header__mobile-nav");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('body').removeClass('mobile-nav-open');
                $('html').removeClass('html-nav-open');
                $('.site-header__mobile-nav').removeClass('nav-active');
            }
          
            var container1 = $("predictive-search form");
            if (!container1.is(e.target) && container1.has(e.target).length === 0) {
                $('predictive-search form').removeClass('active-form');
            }
        });
      }
      appHeight();
    });
  
    const appHeight = () => {
        const doc = document.documentElement;
        // set height window
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
        doc.style.setProperty('--header-height', $('.header-section').outerHeight() + `px`);
        doc.style.setProperty('--header-padding-bottom', $('.site-header__element--nav').outerHeight() + `px`);
    }

    $(window).on('resize', function () {
      appHeight();
    });
  
    function setCookie(cname, cvalue, exdays) {
        console.log('set cookie');
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        console.log('get cookie');
        let name = cname + "=";
        let ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    $(window).on("scroll", function () {
      // Header sticky      
      var st = $(this).scrollTop();
      var siteHeader = $('.header-section').outerHeight();
      var siteHeaderTop = $('.site-header__element--top').outerHeight();
      if ($(window).scrollTop() > siteHeader) {
          $('header').addClass('sticky--active');        
          setTimeout(function() {
            $('header').addClass('sticky--open');     
          }, 100);
      }
      if ($(window).scrollTop() < siteHeaderTop) {
          $('header').removeClass('sticky--active sticky--open');
      }
      if ($(window).scrollTop() > (siteHeaderTop - 25 )) {
          $('.header-item--icons').addClass('icons-hidden');
      } else {
          $('.header-item--icons').removeClass('icons-hidden');
      }
    });
    
})(jQuery);
